import React from 'react';

function Standard1(){
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" id="standard" x="0px" y="0px" viewBox="0 0 124.6 122">
                <g id="standard1">
                    <path className="st8" d="M36.9,53.5v60.7c0,0-0.9,3.3-6.7,3h-20c0,0-8.1-2.1-8.3-11.5V63.5c0,0,1.4-10.4,8.7-10.3
                        C10.5,53.3,37.2,53.5,36.9,53.5z"/>
                    <path className="st8" d="M42.2,55.1v54c0,0,7.2,2.6,10.8,2.9h51.3c0,0,9.2-5.3,7-14.6l-0.5-1.2c0,0,9.5-3.7,5.9-15.8c0,0,5.4-3,5.5-9.1
                        c0,0,1.8-2.9-4.8-7.8c0,0,7.1-6.1,3-13.8c0,0-2.5-6.1-9.7-6.9H77.1c0,0,9.9-19.7,1.5-32c0,0-4.4-6.5-10-7.3c0,0-7.6-2-11,3.3
                        l-0.2,18.9C57.4,25.8,54,38.2,42.2,55.1z"/>
                </g>
        </svg>

    )
}

export default Standard1;